// extracted by mini-css-extract-plugin
export default {"barButton":"iaDPuk"};